export function nextIndex(current, length, delta) {
  if (!length) return 0;
  return (current + delta + length) % length;
}

export function applyMainImage(img, { src, srcset = '', sizes = '', alt = '' }) {
  if (!img || !src) return;
  img.src = src;
  img.srcset = srcset;
  img.sizes = sizes;
  img.alt = alt;
}

export function initProductGallery(container) {
  if (!container || container.dataset.galleryInit === 'true') return null;
  container.dataset.galleryInit = 'true';
  return new ProductGallery(container);
}

export class ProductGallery {
  constructor(container) {
    this.container = container;
    this.thumbs = Array.from(container.querySelectorAll('[data-gallery-thumb]'));
    this.mainImage = container.querySelector('[data-gallery-main]');
    this.currentIndex = Math.max(
      0,
      this.thumbs.findIndex((t) => t.classList.contains('is-active'))
    );
    if (this.currentIndex < 0) this.currentIndex = 0;

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.switchImage(index));
    });

    container.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.step(-1));
    container.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.step(1));

    container.addEventListener('keydown', (e) => {
      if (this.lightbox?.open) return;
      if (e.key === 'ArrowLeft') this.step(-1);
      if (e.key === 'ArrowRight') this.step(1);
    });

    this.lightbox = container.querySelector('[data-gallery-lightbox]');
    this.lightboxImage = container.querySelector('[data-gallery-lightbox-image]');

    container.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => this.openLightbox());
    container.querySelector('[data-gallery-lightbox-close]')?.addEventListener('click', () => this.closeLightbox());
    container.querySelector('[data-gallery-lightbox-prev]')?.addEventListener('click', () => this.step(-1));
    container.querySelector('[data-gallery-lightbox-next]')?.addEventListener('click', () => this.step(1));

    this.lightbox?.addEventListener('click', (e) => {
      if (e.target === this.lightbox) this.closeLightbox();
    });

    document.addEventListener('keydown', (e) => {
      if (!this.lightbox?.open) return;
      if (e.key === 'Escape') this.closeLightbox();
      if (e.key === 'ArrowLeft') this.step(-1);
      if (e.key === 'ArrowRight') this.step(1);
    });
  }

  step(delta) {
    if (this.thumbs.length < 2) return;
    this.switchImage(nextIndex(this.currentIndex, this.thumbs.length, delta));
  }

  switchImage(index) {
    const thumb = this.thumbs[index];
    if (!thumb || !this.mainImage) return;

    applyMainImage(this.mainImage, {
      src: thumb.dataset.fullSrc,
      srcset: thumb.dataset.fullSrcset || '',
      sizes: thumb.dataset.fullSizes || '',
      alt: thumb.dataset.alt || '',
    });

    this.thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    this.currentIndex = index;
    if (this.lightbox?.open) this.syncLightboxImage();
  }

  openLightbox() {
    if (!this.lightbox || !this.lightboxImage || !this.mainImage) return;
    this.syncLightboxImage();
    if (typeof this.lightbox.showModal === 'function') {
      this.lightbox.showModal();
    } else {
      this.lightbox.setAttribute('open', '');
    }
  }

  closeLightbox() {
    if (!this.lightbox) return;
    if (typeof this.lightbox.close === 'function') {
      this.lightbox.close();
    } else {
      this.lightbox.removeAttribute('open');
    }
  }

  syncLightboxImage() {
    const thumb = this.thumbs[this.currentIndex];
    const src = thumb?.dataset.fullSrc || this.mainImage?.src;
    const alt = thumb?.dataset.alt || this.mainImage?.alt || '';
    if (!this.lightboxImage || !src) return;
    this.lightboxImage.src = src.replace(/width=\d+/, 'width=2000');
    this.lightboxImage.alt = alt;
  }
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-product-gallery]').forEach((el) => {
    initProductGallery(el);
  });
}
